<template>
  <v-layout>
    <v-tooltip
      v-if="disabled && tooltip"
      top
    >
      <template v-slot:activator="{ on }">
        <v-chip
          v-if="!menu"
          text-color="white"
          label
          small
          :color="disabled ? 'grey' : value ? 'green' : 'red'"
          v-on="on"
          @click="disabled ? false : (menu = true)"
        >
          {{ value ? "Да" : "Нет" }}
        </v-chip>
      </template>
      <span>{{ tooltip }}</span>
    </v-tooltip>
    <v-menu
      v-else
      v-model="menu"
      :disabled="disabled"
    >
      <v-chip
        slot="activator"
        text-color="white"
        label
        small
        :color="disabled ? 'grey' : value ? 'green' : 'red'"
      >
        {{ value ? "Да" : "Нет" }}
      </v-chip>
      <v-list>
        <v-list-tile
          v-if="!value"
          @click="changeLabel(true)"
        >
          <v-list-tile-title>Да</v-list-tile-title>
        </v-list-tile>
        <v-list-tile
          v-if="value"
          @click="changeLabel(false)"
        >
          <v-list-tile-title>Нет</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
    <v-dialog
      v-if="column === 'unloaded'"
      v-model="dialogDatePicker"
      width="323"
    >
      <v-card>
        <v-card-title class="subheading pb-0">
          Выберите Дату прибытия в звене
        </v-card-title>
        <v-card-text>
          <v-date-picker
            v-model="unloadingDate"
            no-title
            locale="ru-ru"
            header-color="primary"
          />
        </v-card-text>
        <v-card-actions>
          <v-btn
            small
            flat
            class="primary"
            @click="changeUnloadingDate(unloadingDate)"
          >
            Сохранить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
export default {
  props: ["value", "item", "column", "disabled", "tooltip"],
  data() {
    return {
      dialogDatePicker: false,
      unloadingDate: new Date().toISOString(),
      menu: false,
    };
  },
  methods: {
    changeLabel(value) {
      if (this.column === "inCar") {
        const routeItem = { ...this.item };
        routeItem.inCar = value;
        routeItem.deliveryToUnloadingPlaceFact = routeItem.inCar
          ? new Date().toISOString()
          : null;
        this.$store.commit("route/setEditableRouteItem", routeItem);
        this.$emit("change", routeItem.inCar);
      } else if (this.column === "unloaded") {
        const routeItem = { ...this.item };
        routeItem.unloaded = value;
        this.$store.commit("route/setEditableRouteItem", routeItem);
        if (value) {
          this.dialogDatePicker = true;
        } else {
          this.changeUnloadingDate(null);
        }
      }
    },
    changeUnloadingDate(date) {
      const routeItem = { ...this.$store.getters["route/editableRouteItem"] };
      routeItem.unloadingDate = date;
      this.$store.commit("route/setEditableRouteItem", routeItem);
      this.dialogDatePicker = false;
      this.$emit("change");
    },
  },
};
</script>
